import React from 'react';
import { Checkbox, Grid, FormControlLabel, TextField } from '@mui/material';

import FrequencySelect from 'components/FrequencySelect';
import {
  HideMarkerWithIndex,
  MarkerHistoryForm,
  MarkerWithIndex,
} from './types';
import { Control, Controller, UseFormWatch } from 'react-hook-form';

interface Props {
  watch: UseFormWatch<MarkerHistoryForm>;
  control: Control<MarkerHistoryForm>;
}

const MarkerInputs = ({ watch, control }: Props) => {
  return (
    <Grid container item xs={12} spacing={1}>
      <Grid item xs={1}>
        <span style={{ padding: '0', margin: '0' }}>Hide</span>
      </Grid>
      {[1, 2, 3, 4].map((i) => (
        <React.Fragment key={i}>
          <Grid container item xs={12} spacing={1}>
            <Grid item xs={1} style={{ minWidth: '2.5rem' }}>
              <Controller
                name={('hideMarker' + i) as HideMarkerWithIndex}
                control={control}
                rules={{ required: false }}
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    name={`hideMarker${i}`}
                    checked={!!value}
                    onChange={onChange}
                  />
                )}
              />
            </Grid>
            <Controller
              name={('marker' + i) as MarkerWithIndex}
              control={control}
              rules={{ required: false }}
              render={({ field: { onChange, value } }) => (
                <>
                  <Grid item xs={6}>
                    <TextField
                      label={`Marker ${i}`}
                      size='small'
                      name='value'
                      type='number'
                      value={value?.value}
                      onChange={(e) => {
                        onChange({ ...value, value: e.target.value });
                      }}
                    />
                  </Grid>
                  <Grid item xs={3} style={{ minWidth: '6rem' }}>
                    <FrequencySelect
                      selected={value?.frequency ? value.frequency : ''}
                      onChange={(e) => {
                        onChange({ ...value, frequency: e.target.value });
                      }}
                      name='frequency'
                    />
                  </Grid>
                </>
              )}
            />
          </Grid>
        </React.Fragment>
      ))}
      <Grid container item style={{ marginLeft: '11px' }}>
        <Grid item xs={6}>
          <Controller
            name='hideM2M1'
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    name='hideM2M1'
                    checked={!!value}
                    onChange={onChange}
                  />
                }
                label='Hide M2 - M1'
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            name='hideM3M1'
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    name='hideM3M1'
                    checked={value}
                    onChange={onChange}
                  />
                }
                label='Hide M3 - M1'
              />
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            name='hideM4M1'
            control={control}
            rules={{ required: false }}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    name='hideM4M1'
                    checked={!!value}
                    onChange={onChange}
                  />
                }
                label='Hide M4 - M1'
              />
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MarkerInputs;
